module.exports = __webpack_public_path__ + "img/video.b55aa859.svg";